module.exports = "/static-assets/_next/static/images/liminal-eb741673f263f72a5e3731426579a84c.png";